/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ベータ版フラグ更新APIのリクエストボディ
 * @export
 * @interface UpdatePressReleaseEditorBetaFlgRequestBody
 */
export interface UpdatePressReleaseEditorBetaFlgRequestBody {
    /**
     * ベータ版フラグ
     * @type {boolean}
     * @memberof UpdatePressReleaseEditorBetaFlgRequestBody
     */
    betaFlg: boolean;
}

export function UpdatePressReleaseEditorBetaFlgRequestBodyFromJSON(json: any): UpdatePressReleaseEditorBetaFlgRequestBody {
    return UpdatePressReleaseEditorBetaFlgRequestBodyFromJSONTyped(json, false);
}

export function UpdatePressReleaseEditorBetaFlgRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePressReleaseEditorBetaFlgRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'betaFlg': json['beta_flg'],
    };
}

export function UpdatePressReleaseEditorBetaFlgRequestBodyToJSON(value?: UpdatePressReleaseEditorBetaFlgRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'beta_flg': value.betaFlg,
    };
}

